// utils/localStorageHelpers.js

const localStorageHelper = {
    getItem: (key, defaultValue = null) => {
        try {
            const storedValue = localStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : defaultValue;
        } catch (error) {
            console.error(`Error getting localStorage item "${key}":`, error);
            return defaultValue;
        }
    },

    setItem: (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error setting localStorage item "${key}":`, error);
        }
    },

    removeItem: (key) => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing localStorage item "${key}":`, error);
        }
    },

    clearStorage: (keys = []) => {
        keys.forEach((key) => localStorageHelper.removeItem(key));
    },

    itemExists: (key) => {
        try {
            return localStorage.getItem(key) !== null;
        } catch (error) {
            console.error(`Error checking existence of localStorage item "${key}":`, error);
            return false;
        }
    }
};

export default localStorageHelper;
